import React, { useState } from "react";
import { View, ScrollView } from "react-native";
import { styles } from "../style/styles.js";
import { getCurrentDateTime } from "../services/Functions.js";
import {
  ImageComponent,
  InfoComponent,
  CustomTableHeader,
  CustomTitle,
  FinishPieces,
} from "../components/FullComponent.js";
import DynamicFlatList from "../components/Common/ComponentDynamicList.js";
import { LinearGradient } from "expo-linear-gradient";
import { backgroundColor } from "../constants/Constants.js";

export default function QualityReceptionScreen({ route }) {
  const screenName = "QualityReceptionScreen";
  const data = route.params.infoData;
  const columns = [
    { name: "Operario", width: "15%" },
    { name: "Fecha", width: "15%" },
    { name: "Piezas", width: "15%" },
    { name: "Peso", width: "15%" },
    { name: "Comentario", width: "25%" },
    { name: "", width: "15%" },
  ];

  return (
    <LinearGradient
      colors={backgroundColor()}
      style={styles.backgrounOptionDos}>
      <ScrollView style={{ flex: 1 }}>
        <View style={{ flex: 1 }}>
          <View style={styles.row}>
            <InfoComponent data={data} />
            <View style={styles.column}>
              <View style={{ flexDirection: "row" }}></View>
              <View>
                <View style={{ flexDirection: "row", padding: 8 }}>
                  <FinishPieces />
                </View>
                <View>
                  <CustomTitle title='Control Calidad / Recepción' />
                  <CustomTableHeader columns={columns} />
                  <DynamicFlatList
                    data={Object.values(data.recepcion)}
                    itemWidths={["15%", "15%", "15%", "15%", "25%", "15%"]}
                    screenName='QualityReceptionScreen'
                  />
                </View>
              </View>
            </View>
          </View>
          <ImageComponent data={data} />
        </View>
      </ScrollView>
    </LinearGradient>
  );
}
